'use client'

import { useEffect } from 'react'

// Interatividade dos templates Designer (nav-scroll, drawer mobile, theme-toggle).
// Componente client separado para que a factory makeDesignerTemplate possa ser
// um Server Component (chamada no server pelo registry). Uma pagina renderiza um
// template por vez, entao consultar o document e seguro.
//
// Theme toggle (atualizado 2026-05-30):
//   - Bootstrap no <head> de app/layout.tsx ja aplica light/dark antes do paint
//     baseado em localStorage 'canonical-theme'. Aqui apenas:
//     1. Sincronizamos os icones (sol/lua) com o estado atual do <html>
//     2. No click do #theme-toggle: alternamos, gravamos localStorage e ressincronizamos
export function TemplateRuntime() {
  useEffect(() => {
    const nav = document.querySelector('#topnav')
    const onScroll = () => nav?.classList.toggle('is-scrolled', window.scrollY > 8)
    if (nav) {
      window.addEventListener('scroll', onScroll, { passive: true })
      onScroll()
    }

    const drawer = document.querySelector('#drawer')
    const overlay = document.querySelector('#drawer-overlay')
    const menuToggle = document.querySelector('#menu-toggle')
    const drawerClose = document.querySelector('#drawer-close')
    const open = () => {
      drawer?.classList.add('is-open')
      overlay?.classList.add('is-open')
      drawer?.setAttribute('aria-hidden', 'false')
      document.body.style.overflow = 'hidden'
    }
    const close = () => {
      drawer?.classList.remove('is-open')
      overlay?.classList.remove('is-open')
      drawer?.setAttribute('aria-hidden', 'true')
      document.body.style.overflow = ''
    }
    menuToggle?.addEventListener('click', open)
    drawerClose?.addEventListener('click', close)
    overlay?.addEventListener('click', close)
    const drawerLinks = Array.from(document.querySelectorAll('#drawer a'))
    drawerLinks.forEach((a) => a.addEventListener('click', close))

    const themeToggle = document.querySelector('#theme-toggle')
    const iconSun = document.querySelector<HTMLElement>('#icon-sun')
    const iconMoon = document.querySelector<HTMLElement>('#icon-moon')
    const syncIcons = () => {
      const dark = document.documentElement.classList.contains('dark')
      if (iconSun) iconSun.style.display = dark ? 'none' : ''
      if (iconMoon) iconMoon.style.display = dark ? '' : 'none'
    }
    // Sincroniza icones com o estado real aplicado pelo bootstrap inline.
    syncIcons()
    const onTheme = () => {
      const root = document.documentElement
      const wasDark = root.classList.contains('dark')
      const next = wasDark ? 'light' : 'dark'
      root.classList.remove('dark', 'light')
      root.classList.add(next)
      try {
        localStorage.setItem('canonical-theme', next)
      } catch (e) {
        // localStorage indisponivel (private mode, quota) - tudo bem,
        // a escolha so nao persiste entre paginas/sessoes.
      }
      syncIcons()
    }
    themeToggle?.addEventListener('click', onTheme)

    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') close() }
    document.addEventListener('keydown', onKey)

    return () => {
      window.removeEventListener('scroll', onScroll)
      document.removeEventListener('keydown', onKey)
      menuToggle?.removeEventListener('click', open)
      drawerClose?.removeEventListener('click', close)
      overlay?.removeEventListener('click', close)
      drawerLinks.forEach((a) => a.removeEventListener('click', close))
      themeToggle?.removeEventListener('click', onTheme)
      document.body.style.overflow = ''
    }
  }, [])

  return null
}
